import React from 'react';
import Table from "./table";
import './table-block.scss'
import {useTranslation} from "react-i18next";

function TableBlock() {
    const { t } = useTranslation()
    return (
        <div className="table-block">

            <div className="table-block__wrapper container">
                <h3 className="table-block__title title" data-aos="fade-up">{t('table_block.title')}</h3>

                <Table/>

            </div>

        </div>
    );
}

export default TableBlock;